module.exports = __webpack_public_path__ + "static/media/photo-1.271efb73.jpg";